module.exports = __webpack_public_path__ + "SuryaVamsi4-946eab67.png";